import { useContext } from "react";
import clsx from "clsx";
import makeStyles from "@material-ui/core/styles/makeStyles";
import PageContext from "@PageContext";
import Container from "@material-ui/core/Container";
import Logo from "./logo";
import ReactMenu01 from "@micado-digital/react-menu/ReactMenu01";
import { useScroll } from "./../../../hooks/useScroll";

const useStyles = makeStyles((theme) => ({
	root: {
		background: theme.palette.primary.main,
		height: 64,
		left: 0,
		padding: theme.spacing(0, 2),
		position: "fixed",
		top: 0,
		width: "100%",
		zIndex: 4,
		"& .header-wrapper": {
			display: "flex",
			height: "100%",
			justifyContent: "space-between"
		},
		"& .logo a": {
			transition: theme.transitions.create(["height", "padding", "width"], {
				easing: theme.transitions?.easing?.easeInOut,
				duration: theme.transitions?.duration?.shorter
			})
		}
	},
	fixedHeader: {
		"& .logo a": {
			alignItems: "center",
			display: "flex",
			height: 64,
			padding: theme.spacing(0, 2),
			width: 100,
			[theme.breakpoints.up("sm")]: {
				height: 96,
				padding: theme.spacing(0, 3),
				width: 160
			}
		}
	}
}));

const Header = () => {
	const [pageData] = useContext(PageContext);
	const css = useStyles();

	const { scrollY } = useScroll();

	const mainmenu = pageData?.menuGroups?.find((item) => item.title === "Hauptmenü");
	const metamenu = pageData?.menuGroups?.find((item) => item.title === "Metamenü");

	const header = document.querySelector("header");

	return (
		<header className={clsx("header", css.root, { [css.fixedHeader]: scrollY > 100 })}>
			<Container className="header-wrapper" maxWidth="lg">
				<Logo />
				<ReactMenu01
					backLabel="Zurück"
					desktopSubContainerEvent="mouseenter"
					desktopSubContainerLayoutColumn="vertical"
					iconBottom="/img/icons/chevron-down.svg"
					iconClose="/img/icons/close.svg"
					iconLeft="/img/icons/chevron-left.svg"
					iconMenu="/img/icons/menu.svg"
					iconRight="/img/icons/chevron-right.svg"
					mainmenu={mainmenu}
					metamenu={metamenu}
					toggleAlign="ltr"
					toggleLabel="Menü"
					onClose={() => {
						header && header.classList.remove("menu-visible");
					}}
					onOpen={() => {
						header && header.classList.add("menu-visible");
					}}
				/>
			</Container>
		</header>
	);
};

export default Header;
